import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { ContextMenu } from 'primeng/contextmenu';
import { MenuItem, MessageService } from 'primeng/api';
import { DetailsPage as ClientDetailsPage } from '../../clients/details/details.page';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalService } from '../../api/global.service';
import { CreatePage as ClientCreatePage } from '../../clients/create/create.page';
import { CreatePage as CompanyCreatePage } from '../../companies/create/create.page';
import { CreateComponent as GroupCreateComponent } from '../groups/create/create.component'
import { SelectComponent as GroupSelectComponent } from '../groups/select/select.component';
import { DetailsPage as CompaniesDetailsPage } from '../../companies/details/details.page';
import { SelectCompanyRoleComponent } from './select-company-role/select-company-role.component';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { guid } from '@fullcalendar/core/internal';
import { MailingLabelLines } from '../../services/address.util';



@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss'],
})
export class AddressBookComponent implements OnInit {
  clients: any[] = [];
  client_groups: any[] = [];
  client_tags: any[] = [];
  companies: any[] = [];
  company_groups: any[] = [];
  company_tags: any[] = [];
  clients_roles: any[] = [];
  expanded_groups: string[] = []; // Track expanded group GUIDs

  combined_data = false;
  selection_mode = false;
  @Input() in_selected_companies: any[] = [];
  @Input() in_selected_contacts: any[] = [];
  @Input() external_selection_mode = false;
  @Input() allow_client_selection = true;
  @Input() allow_non_client_selection = true;
  @Input() allow_company_selection = true;
  @Input() allow_contact_selection = true;
  @Input() allow_company_group_selection = true;
  @Input() allow_contact_group_selection = true;
  // Hides the per-role radio button on a company's role groups - the caller only wants a plain
  // company selection (e.g. booking an appointment, where there's nowhere to act on a role).
  @Input() allow_role_selection = true;
  @Input() main_title = "Clients";
  @Input() max_allowed_selections: number = 9999999999;

  get totalSelected(): number {
    return this.selectedCompanyGuids.size + this.selectedContactGuids.size +
           this.selectedCompanyGroupGuids.size + this.selectedContactGroupGuids.size;
  }

  get isAtMaxSelections(): boolean {
    return this.totalSelected >= this.max_allowed_selections;
  }

  client_context_items: MenuItem[] | undefined;
  company_context_items: MenuItem[] | undefined;
  group_context_items: MenuItem[] | undefined;
  @ViewChild('client_context_menu') client_context_menu: ContextMenu;
  @ViewChild('company_context_menu') company_context_menu: ContextMenu;
  @ViewChild('group_context_menu') group_context_menu: ContextMenu;

  // Selection state
  selectedCompanyGuids: Set<string> = new Set();
  selectedContactGuids: Set<string> = new Set();
  selectedClientGuids: Set<string> = new Set();
  selectedCompanyGroupGuids: Set<string> = new Set();
  selectedContactGroupGuids: Set<string> = new Set();
  selectedCompanyRoles: Map<string, string> = new Map();



  current_context_client: any = null;
  current_context_company: any = null;
  current_context_group: any = null;
  highlighting_company = false;
  highlighted_row: '';
  highlighted_info_contact: any = null;
  highlighted_info_company: any = null;
  expand_companies = false;
  expand_contacts = false;
  isCompanyGroup = false;
  isClientGroup = false;

  //Vars for HTML
  @Input() expanded_clients = false;
  @Input() expanded_non_clients = false;
  clientSearchTerm = '';
  nonClientSearchTerm = '';
  client_list_filter: 'all' | 'companies' | 'contacts' = 'all';
  non_client_list_filter: 'all' | 'companies' | 'contacts' = 'all';
  globalSearchTerm = '';
  globalFilteredCompanies: any[] = [];
  globalFilteredContacts: any[] = [];
  hide_empty_groups = false;

  non_grouped_companies_clients = 0;
  non_grouped_companies_not_clients = 0;
  non_grouped_contacts_clients = 0;
  non_grouped_contacts_not_clients = 0;

  non_grouped_companies_clients_expanded = false;
  non_grouped_companies_not_clients_expanded = false;
  non_grouped_contacts_clients_expanded = false;
  non_grouped_contacts_not_clients_expanded = false;

  Log() {
    console.log("TEST");
    console.log("Company Groups: ", this.company_groups);
    console.log("Client Groups: ", this.client_groups);
    console.log("Companies: ", this.companies);
    console.log("Clients: ", this.clients);

  }
  JSONSTR(data) {
    return JSON.stringify(data);
  }
  constructor(private apiService: ApiService, private modalController: ModalController, public globalService: GlobalService,
    private alertController: AlertController) { }

  ngOnInit() {
    if (this.external_selection_mode) this.selection_mode = true;
    this.company_context_items = [
      {
        label: 'Edit Company',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.presentCompanyDetailsModal(this.current_context_company);
        }
      },
      {
        label: 'Manage Company Groups',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.presentManageCompaniesGroups(this.current_context_company);
        }
      },
      {
        label: 'Create Contact',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.presentCreateClientModal(this.current_context_company, null);
        }
      },
      {
        label: 'Select Company',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.selection_mode = true;
          this.selectCompany(this.current_context_company, true);
        }
      }
    ];



    this.GetData();
  }

  async GetData(force_refresh = false) {
    // Save currently expanded groups
    this.expanded_groups = [];
    this.company_groups.forEach(group => {
      if (group.expanded) this.expanded_groups.push(group.guid);
    });
    this.client_groups.forEach(group => {
      if (group.expanded) this.expanded_groups.push(group.guid);
    });

    if (this.clients_roles.length === 0 || force_refresh) {
      const roleData: any = await this.apiService.GetRoles(force_refresh);
      if (roleData && roleData.success) this.clients_roles = roleData.data || [];
    }

    await this.GetClients(force_refresh);
    await this.GetClientGroups(force_refresh);
    //this.GetClientTags();
    await this.GetCompanies(force_refresh);
    await this.GetCompanyGroups(force_refresh);
    this.CombinedData();
    //this.GetCompanyTags();
    this.SelectPreselectedItems();
    this.ShowLastExpanded();
  }

  async Refresh() {
    await this.globalService.presentLoading('Refreshing...', 999999);
    await this.GetData(true);
    this.globalService.dismissLoading();
  }

  async SelectPreselectedItems() {
    // Loop through preselected companies and select them if they exist
    if (this.in_selected_companies && this.in_selected_companies.length > 0) {
      for (const selectedCompany of this.in_selected_companies) {
        const company = this.companies.find(c => c.guid === selectedCompany.guid);
        if (company) {
          this.selectCompany(company, true);
          if (selectedCompany.role_guid) {
            this.selectedCompanyRoles.set(company.guid, selectedCompany.role_guid);
            company.expanded = true;
          }
        }
      }
    }

    // Loop through preselected contacts and select them if they exist  
    if (this.in_selected_contacts && this.in_selected_contacts.length > 0) {
      for (const selectedContact of this.in_selected_contacts) {
        const contact = this.clients.find(c => c.guid === selectedContact.guid);
        if (contact) {
          this.toggleClient(contact, true);
        }
      }
    }
  }

  async GetUpdatedCompany(guid) {
    for (let i = 0; i < this.companies.length; i++) {
      if (this.companies[i].guid === guid) {
        const data: any = await this.apiService.get(`companies/${guid}`);
        if (data.success && data.data && data.data.length > 0) {
          this.companies[i] = data.data[0];
          this.companies[i].expanded = true; // Keep it expanded after update
        }
        break;
      }
    }
    this.CombinedData();
  }

  async GetClients(force_refresh = false) {
    let data: any = await this.apiService.GetClients(force_refresh);
    console.log("New Get Clients", data);
    if (data.success) {
      if(!data.data) data.data = [];
      this.clients = data.data;
    }

    this.non_grouped_contacts_clients = 0;
    this.non_grouped_contacts_not_clients = 0;

    for (const client of this.clients) {
      const hasGroups = Array.isArray(client.groups) && client.groups.length > 0;
      if (!hasGroups) {
        if (client.is_a_client) {
          this.non_grouped_contacts_clients++;
        } else {
          this.non_grouped_contacts_not_clients++;
        }
      }
    }

    if (this.clients && Array.isArray(this.clients)) {
      this.clients.sort((a: any, b: any) => {
        const nameA = (a && a.display_name ? a.display_name : '').toLowerCase();
        const nameB = (b && b.display_name ? b.display_name : '').toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }
    console.log("Clients:", this.clients);
  }
  async GetClientGroups(force_refresh = false) {
    let data: any = await this.apiService.GetGroups('clients', force_refresh);
    if (data.success) {
      this.client_groups = data.data;
    }
    if(!this.client_groups) this.client_groups = [];
    console.log("Client Groups:", this.client_groups);
  }

  async GetClientTags() {
    let data: any = await this.apiService.GetTags('clients');
    if (data.success) {
      this.client_tags = data.data;
    }
    if(!this.client_tags) this.client_tags = [];
    console.log("Client Tags:", this.client_tags);
  }

  async GetCompanies(force_refresh = false) {
    let data: any = await this.apiService.GetCompanies(force_refresh);
    if (data.success) {
      this.companies = data.data;
    }
    if(!this.companies) this.companies = [];
    this.non_grouped_companies_clients = 0;
    this.non_grouped_companies_not_clients = 0;

    for (const company of this.companies) {
      const hasGroups = Array.isArray(company.groups) && company.groups.length > 0;
      if (!hasGroups) {
        if (company.is_a_client) {
          this.non_grouped_companies_clients++;
        } else {
          this.non_grouped_companies_not_clients++;
        }
      }
    }



    console.log("Companies:", this.companies);
  }

  async GetCompanyGroups(force_refresh = false) {
    let data: any = await this.apiService.GetGroups('companies', force_refresh);
    if (data.success) {
      this.company_groups = data.data;
    }
    if(!this.company_groups) this.company_groups = [];
    console.log("Company Groups:", this.company_groups);
  }

  async GetCompanyTags() {
    let data: any = await this.apiService.GetTags('companies');
    if (data.success) {
      this.company_tags = data.data;
    }
    if(!this.company_tags) this.company_tags = [];
    console.log("Company Tags:", this.company_tags);
  }

  isCompanyInGroup(company, group) {

    if (!company.groups) return false;
    if (group.title == "New Subgroup TWO") {
      console.log("~~~~~~~~~~ NEW SUBGROUP TWO ~~~~~~~~~~~~~~");
      console.log("Company: ", company);
      console.log("GROUP: ", group);
      console.log("Find: ", (company.groups.findIndex(item => item.guid === group.guid) > -1));
      console.log("~~~~~~~~~~");
    }
    return (company.groups.findIndex(item => item.guid === group.guid) > -1);
  }

  isClientInGroup(client, group) {
    if (!client.groups) return false;
    return (client.groups.findIndex(item => item.guid === group.guid) > -1);
  }

  CombinedData() {
    this.company_groups.forEach(group => {
      if (!group.companies) {
        group.companies = [];
      }
      for (let i = 0; i < this.companies.length; i++) {
        const company = this.companies[i];
        if (!company.groups) continue;
        for (let j = 0; j < company.groups.length; j++) {
          const company_group = company.groups[j];

          if (company_group.guid == group.guid) {
            if (group.companies.findIndex((c: any) => c.guid === company.guid) === -1) {
              group.companies.push(company);
            }
          }

        }
      }
      // group.companies = this.companies.filter(company => this.isCompanyInGroup(company, group));
    });
    this.client_groups.forEach(group => {
      group.clients = this.clients.filter(client => this.isClientInGroup(client, group));
    });
    for (let i = 0; i < this.companies.length; i++) {
      const company = this.companies[i];
      if (company.clients && Array.isArray(company.clients)) {
        for (let j = 0; j < company.clients.length; j++) {
          let client = company.clients[j];
          const roleData = {
            role_guid: client.role_guid || null,
            is_default_for_role: !!client.is_default_for_role,
          };
          for (let k = 0; k < this.clients.length; k++) {
            const c = this.clients[k];
            if (c.guid === client.guid) {
              company.clients[j] = { ...c, ...roleData };
              break;
            }
          }
        }
      }
    }

    for (const company of this.companies) {
      if (company.clients && Array.isArray(company.clients)) {
        company.clients.sort((a: any, b: any) => {
          const defaultGuid = company.default_client_guid || '';
          const aIsDefault = a && a.guid === defaultGuid;
          const bIsDefault = b && b.guid === defaultGuid;
          if (aIsDefault && !bIsDefault) return -1;
          if (!aIsDefault && bIsDefault) return 1;

          const aIsClient = !!(a && a.is_a_client);
          const bIsClient = !!(b && b.is_a_client);
          if (aIsClient && !bIsClient) return -1;
          if (!aIsClient && bIsClient) return 1;

          const nameA = (a && a.display_name ? a.display_name : '').toLowerCase();
          const nameB = (b && b.display_name ? b.display_name : '').toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }
      // Set default_client reference
      if (company.default_client_guid && company.clients && Array.isArray(company.clients)) {
        company.default_client = company.clients.find(client => client && client.guid === company.default_client_guid) || null;
      }
      // Pre-compute role groups so template doesn't recreate arrays on every change detection
      company.clients_by_role = this.computeClientsByRole(company);
    }

    this.UpdateGroupsCount();
    this.combined_data = true;
    console.log("Companies: ", this.companies);
  }

  UpdateGroupsCount() {
    if (this.company_groups) {
      for (const group of this.company_groups) {
        group.client_objects = [];
        group.non_client_objects = [];
        for (const company of this.companies) {
          if (company.groups && Array.isArray(company.groups)) {
            if (company.groups.some(g => g.guid === group.guid)) {
              if (company.is_a_client) group.client_objects.push(company);
              else group.non_client_objects.push(company);
            }
          }
        }
      }
      for (const group of this.company_groups) {
        this.UpdateParentGroupsCount(group, this.company_groups);
      }
    }
    if (this.client_groups) {
      for (const group of this.client_groups) {
        group.client_objects = [];
        group.non_client_objects = [];
        for (const client of this.clients) {
          if (client.groups && Array.isArray(client.groups)) {
            if (client.groups.some(g => g.guid === group.guid)) {
              if (client.is_a_client) group.client_objects.push(client);
              else group.non_client_objects.push(client);
            }
          }
        }
      }
      for (const group of this.client_groups) {
        this.UpdateParentGroupsCount(group, this.client_groups);
      }

    }
    console.log("GROUPS WITH COUNTS:", this.company_groups);
  }

  UpdateParentGroupsCount(group, search_group) {

    if (!group.parent_guid) return;
    const parent_group = search_group.find(g => g.guid === group.parent_guid);
    if (parent_group) {
      for (const obj of group.client_objects) {
        if (!parent_group.client_objects.some(o => o.guid === obj.guid)) {
          parent_group.client_objects.push(obj);
        }
      }
      for (const obj of group.non_client_objects) {
        if (!parent_group.non_client_objects.some(o => o.guid === obj.guid)) {
          parent_group.non_client_objects.push(obj);
        }
      }
      if (parent_group.parent_guid) {
        this.UpdateParentGroupsCount(parent_group, search_group);
      }
    }
  }

  ShowLastExpanded() {
    // Restore expanded state for groups that were previously expanded
    if (this.expanded_groups.length === 0) return;
    
    this.company_groups.forEach(group => {
      if (this.expanded_groups.includes(group.guid)) {
        group.expanded = true;
      }
    });
    
    this.client_groups.forEach(group => {
      if (this.expanded_groups.includes(group.guid)) {
        group.expanded = true;
      }
    });
  }


  // Selection logic
  DisableSelectionOnObj(obj_name, guid: string = null) {
    if (this.external_selection_mode) {
      if (this.isAtMaxSelections && guid) {
        if (obj_name === 'contact') return !this.selectedContactGuids.has(guid) && !this.selectedClientGuids.has(guid);
        if (obj_name === 'company') return !this.selectedCompanyGuids.has(guid);
        if (obj_name === 'companyGroup') return !this.selectedCompanyGroupGuids.has(guid);
        if (obj_name === 'contact_group') return !this.selectedContactGroupGuids.has(guid);
      }
      return false;
    }
    // Selection logic
      if (obj_name == 'company') {
        return (
          this.selectedCompanyGroupGuids.size > 0 ||
          this.selectedContactGroupGuids.size > 0 ||
          this.selectedContactGuids.size > 0
        );
      }
      else if (obj_name == 'contact') {
        return (
          this.selectedContactGroupGuids.size > 0 ||
          this.selectedCompanyGroupGuids.size > 0 ||
          this.selectedCompanyGuids.size > 0
        );
      }
      else if (obj_name == 'company_group') {
        return (
          this.selectedContactGroupGuids.size > 0 ||
          this.selectedContactGuids.size > 0 ||
          this.selectedCompanyGuids.size > 0
        );
      }
      else if (obj_name == 'contact_group') {
        return (
          this.selectedCompanyGroupGuids.size > 0 ||
          this.selectedContactGuids.size > 0 ||
          this.selectedCompanyGuids.size > 0
        );
      }
      return false;
  }

  isCompanySelected(guid: string): boolean {
    return this.selectedCompanyGuids.has(guid);
  }

  isCompanyGroupSelected(guid: string): boolean {
    return this.selectedCompanyGroupGuids.has(guid);
  }

  isContactGroupSelected(guid: string): boolean {
    return this.selectedContactGroupGuids.has(guid);
  }

    isClientSelected(guid: string): boolean {
    return this.selectedContactGuids.has(guid);
  }

  GetCompanyByGUID(guid: string) {
    return this.companies.find(company => company.guid === guid);
  }

  async GetCompanyByGUIDCall(guid: string) {
    let data: any = await this.apiService.get(`companies/${guid}`);
    if(data.success) {
      return data.data[0];
    }
  }

  GetContactByGUID(guid: string) {
    return this.clients.find(contact => contact.guid === guid);
  }

  selectCompany(company: any, checked: boolean) {
    if (checked) {
      this.selectedCompanyGuids.add(company.guid);
      if (company.is_a_client) this.selectedClientGuids.add(company.guid);
    } else {
      this.selectedCompanyGuids.delete(company.guid);
      if (company.is_a_client) this.selectedClientGuids.delete(company.guid);
      this.selectedCompanyRoles.delete(company.guid);
    }
  }

  selectCompanyGroup(group: any, checked: boolean) {
    if (checked) {
      this.selectedCompanyGroupGuids.add(group.guid);
    } else {
      this.selectedCompanyGroupGuids.delete(group.guid);
    }
  }

  selectContactGroup(group: any, checked: boolean) {
    if (checked) {
      this.selectedContactGroupGuids.add(group.guid);
    } else {
      this.selectedContactGroupGuids.delete(group.guid);
    }
  }



  toggleClient(client: any, checked: boolean) {
    if (checked) {
      this.selectedContactGuids.add(client.guid);
      if (client.is_a_client) this.selectedClientGuids.add(client.guid);
    } else {
      this.selectedContactGuids.delete(client.guid);
      if (client.is_a_client) this.selectedClientGuids.delete(client.guid);
    }
  }

  // Select All methods for groups and non-grouped items
  selectAllInCompanyGroup(group: any, clientsOnly: boolean) {
    if (!group.companies) return;
    for (const company of group.companies) {
      if (company.is_a_client === clientsOnly) {
        this.selectCompany(company, true);
      }
    }
  }

  selectAllInContactGroup(group: any, clientsOnly: boolean) {
    if (!group.clients) return;
    for (const client of group.clients) {
      if (client.is_a_client === clientsOnly) {
        this.toggleClient(client, true);
      }
    }
  }

  selectAllNonGroupedCompanies(clientsOnly: boolean) {
    for (const company of this.companies) {
      if (company.is_a_client === clientsOnly && !company.groups) {
        this.selectCompany(company, true);
      }
    }
  }

  selectAllNonGroupedContacts(clientsOnly: boolean) {
    for (const client of this.clients) {
      if (client.is_a_client === clientsOnly && !client.groups) {
        this.toggleClient(client, true);
      }
    }
  }

  // Helper methods for virtual scrolling in groups
  getGroupCompanies(group: any, clientsOnly: boolean): any[] {
    if (!group.companies) return [];
    return group.companies.filter(company => company.is_a_client === clientsOnly);
  }

  getGroupClients(group: any, clientsOnly: boolean): any[] {
    if (!group.clients) return [];
    return group.clients.filter(client => client.is_a_client === clientsOnly);
  }

  // Helper methods for non-grouped items virtual scrolling
  getNonGroupedCompanies(clientsOnly: boolean): any[] {
    return this.companies.filter(company => company.is_a_client === clientsOnly && !company.groups);
  }

  getNonGroupedContacts(clientsOnly: boolean): any[] {
    return this.clients.filter(client => client.is_a_client === clientsOnly && !client.groups);
  }

  // Helper for company clients in tree
  filteredCompanyClients(company: any): any[] {
    return Array.isArray(company.clients) ? company.clients : [];
  }

  getClientRoleName(role_guid: string): string {
    if (!role_guid) return 'No Role';
    const role = this.clients_roles.find(r => r.guid === role_guid);
    return role ? role.title : 'No Role';
  }

  computeClientsByRole(company: any): { role_guid: string, role_name: string, level: number | null, clients: any[] }[] {
    const clients = Array.isArray(company.clients) ? company.clients : [];
    const roleMap = new Map<string, { role_guid: string, role_name: string, level: number | null, clients: any[] }>();
    for (const client of clients) {
      const role_guid = client.role_guid || 'no_role';
      const role_name = this.getClientRoleName(client.role_guid);
      const level = this.getClientRoleLevel(client.role_guid);
      if (!roleMap.has(role_guid)) {
        roleMap.set(role_guid, { role_guid, role_name, level, clients: [] });
      }
      roleMap.get(role_guid).clients.push(client);
    }
    const groups = Array.from(roleMap.values()).sort((a, b) => {
      if (a.role_guid === 'no_role') return 1;
      if (b.role_guid === 'no_role') return -1;
      if (a.level != null && b.level != null) return a.level - b.level;
      if (a.level != null) return -1;
      if (b.level != null) return 1;
      return a.role_name.localeCompare(b.role_name);
    });
    for (const group of groups) {
      group.clients.sort((a: any, b: any) => {
        if (a.is_default_for_role && !b.is_default_for_role) return -1;
        if (!a.is_default_for_role && b.is_default_for_role) return 1;
        return 0;
      });
    }
    return groups;
  }

  toggleCompanyRole(company: any, role_guid: string) {
    const current = this.selectedCompanyRoles.get(company.guid);
    if (current === role_guid) {
      this.selectedCompanyRoles.delete(company.guid);
    } else {
      this.selectedCompanyRoles.set(company.guid, role_guid);
      if (!this.isCompanySelected(company.guid)) {
        this.selectCompany(company, true);
      }
    }
  }

  isRoleSelected(company_guid: string, role_guid: string): boolean {
    return this.selectedCompanyRoles.get(company_guid) === role_guid;
  }

  getClientRoleLevel(role_guid: string): number | null {
    if (!role_guid || role_guid === 'no_role') return null;
    const role = this.clients_roles.find(r => r.guid === role_guid);
    return role ? role.level : null;
  }

  generateRoleLevelTooltip(role_guid: string, roleGroup?: any): string {
    const defaultClient = roleGroup?.clients?.find((c: any) => c.is_default_for_role);

    const buildDefaultClientSection = (label: string) => {
      if (!defaultClient) return '';
      return `<hr/><b>${label}</b><br/>` + this.GenerateClientTooltip(defaultClient);
    };

    if (!role_guid || role_guid === 'no_role') {
      if (defaultClient) {
        return `<b>Default Contact for this Role:</b><br/>` + this.GenerateClientTooltip(defaultClient);
      }
      return '';
    }

    const role = this.clients_roles.find(r => r.guid === role_guid);
    if (!role || role.level == null) {
      if (defaultClient) {
        return `<b>Default Contact for this Role:</b><br/>` + this.GenerateClientTooltip(defaultClient);
      }
      return '';
    }

    const level = role.level;
    const accessRoles = this.clients_roles
      .filter(r => r.level != null && r.level <= level)
      .sort((a, b) => a.level - b.level);
    let msg = `Anybody with this level or higher access (Level 1 being highest) will be able to see these projects.<br/>`;
    msg += accessRoles.map(r => `&bull; ${r.title} (Level ${r.level})`).join('<br/>');
    msg += buildDefaultClientSection('Default Contact for this Role:');
    return msg;
  }



  onContextMenuClient(event: MouseEvent, client: any, company: any) {
    event.preventDefault();
    if (this.selection_mode && !this.external_selection_mode) return;
    this.isCompanyGroup = false;
    this.isClientGroup = true;
    this.client_context_items = [
      {
        label: 'Details / Edit Contact',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.presentDetailsModal(this.current_context_client);
        }
      },
      {
        label: 'Select Contact',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.selection_mode = true;
          this.toggleClient(this.current_context_client, true);
        }
      }
      // {
      //   label: 'Delete',
      //   icon: 'pi pi-user-plus',
      //   command: () => {
      //     this.DeleteContact(this.current_context_client,this.current_context_company);
      //   }
      // },
    ];
    if (company != null) {
      if (company.default_client_guid !== client.guid) {
        this.client_context_items.push({
          label: 'Set as Company Default Contact',
          icon: 'pi pi-user-plus',
          command: () => {
            this.setAsDefaultContact(this.current_context_client);
          }
        });
      }
      this.client_context_items.push({
        label: 'Remove from Company',
        icon: 'pi pi-user-plus',
        command: () => {
          this.removeFromCompany(this.current_context_client, this.current_context_company);
        }
      });
    }
    if (client.is_a_client) {
      this.client_context_items.push({
        label: 'Remove from Clients',
        icon: 'pi pi-user-plus',
        command: () => {
          this.ChangeContactClientStatus(client, false);
        }
      });
    }
    else {
      this.client_context_items.push({
        label: 'Make a Client',
        icon: 'pi pi-user-plus',
        command: () => {
          this.ChangeContactClientStatus(client, true);
        }
      });
    }
    // Always listed so it's discoverable; disabled (with a hover reason) when there's no valid email to invite.
    const has_valid_email = !!client.email && this.globalService.validateEmail(client.email);
    this.client_context_items.push({
      label: client.active ? 'Remove Portal Access' : 'Invite to Portal',
      icon: client.active ? 'fa-solid fa-cloud-arrow-down' : 'fa-solid fa-cloud-arrow-up',
      disabled: !has_valid_email,
      title: has_valid_email ? null : 'This contact does not have a valid email address.',
      command: () => {
        this.TogglePortalAccess(client);
      }
    });

    event.preventDefault();
    // Show the context menu at the mouse position
    this.current_context_client = client;
    if (company != null) {
      this.current_context_company = company;
      console.log("Set Company: ", company);
    }
    this.client_context_menu.show(event);

  }

  onContextMenuCompany(event: MouseEvent, company: any) {
    event.preventDefault();
    if (this.selection_mode) return;
    this.current_context_company = company;
    this.company_context_menu.show(event);
    this.isCompanyGroup = true;
    this.isClientGroup = false;

  }

  onContextMenuGroup(event: MouseEvent, group: any, isCompanyGroup, isClientGroup) {
    event.preventDefault();
    if (this.selection_mode) return;
    console.log(group);
    console.log("is client groups: ", isClientGroup);
    this.current_context_group = group;
    console.log("Current Context Group: ", this.current_context_group);
    this.isCompanyGroup = isCompanyGroup;
    this.isClientGroup = isClientGroup;
    this.group_context_items = [
      {
        label: 'Move / Edit Group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.UpdateGroup(this.current_context_group);
        }
      },
      {
        label: 'Delete Group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.DeleteGroup(this.current_context_group);
        }
      },
      {
        separator: true
      },
      {
        label: 'Add new Subgroup',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.AddNewGroup(this.current_context_group,isCompanyGroup);
        }
      },
      {
        separator: true
      },
      {
        label: 'Move all ' + (this.isCompanyGroup ? "companies" : "contacts") + ' to another group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.MoveToAnotherGroup(this.current_context_group, true);
        }
      },
      {
        label: 'Copy all ' + (this.isCompanyGroup ? "companies" : "contacts") + ' to another group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.MoveToAnotherGroup(this.current_context_group, false);
        }
      },
      {
        label: 'Remove all ' + (this.isCompanyGroup ? "companies" : "contacts") + ' from group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          this.RemoveFromGroup(this.current_context_group, true);
        }
      },
      {
        separator: true
      },
      {
        label: 'Add new ' + (this.isCompanyGroup ? "company" : "contact") + ' to this group',
        icon: 'fa-solid fa-circle-info',
        command: () => {
          if (this.isCompanyGroup) {
            this.presentCreateCompanyModal(this.current_context_group);
          }
          else {
            this.presentCreateClientModal(null, this.current_context_group);
          }
        }
      },
      {
        separator: true
      },
      {
        label: 'Search Group',
        icon: 'fa-solid fa-circle-info',
        command: () => {

        }
      }
    ];
    this.group_context_menu.show(event);
    event.preventDefault();

  }

  async highlightCompnany(company) {
    if (company.guid == this.highlighted_row) return;
    this.highlighted_info_contact = '';
    this.highlighted_info_company = '';
    this.highlighting_company = true;
    let data: any = await this.apiService.get(`companies/${company.guid}`);
    if (data.success) this.highlighted_info_company = data.data[0];
    console.log("HIGHLIGHTED INFO: ", this.highlighted_info_company);
    let default_client_data: any = await this.apiService.get(`clients/${this.highlighted_info_company.default_client_guid}`);
    if (default_client_data.success) this.highlighted_info_contact = default_client_data.data[0];


    if (this.highlighted_info_company && this.highlighted_info_company.custom_data) {
      try {
        this.highlighted_info_company.custom_data = JSON.parse(this.highlighted_info_company.custom_data);
      } catch (e) {
        console.error('Failed to parse custom_data:', e);
      }
    }

    if (this.highlighted_info_contact && this.highlighted_info_contact.custom_data) {
      try {
        this.highlighted_info_contact.custom_data = JSON.parse(this.highlighted_info_contact.custom_data);
      } catch (e) {
        console.error('Failed to parse custom_data:', e);
      }
    }
    this.AddContactCompanyInfo(this.highlighted_info_contact);

    this.highlightRow(company.guid);
  }

  async highlightClient(client, allowExpand) {
    if (!allowExpand) {
      client.guid = client.user_details_guid
    };

    if (client.guid == this.highlighted_row) return;
    this.highlighted_info_contact = '';
    this.highlighted_info_company = '';
    this.highlighting_company = false;
    let data: any = await this.apiService.get(`clients/${client.guid}`);
    if (data.success) this.highlighted_info_contact = data.data[0];
    if (this.highlighted_info_contact && this.highlighted_info_contact.custom_data) {
      try {
        this.highlighted_info_contact.custom_data = JSON.parse(this.highlighted_info_contact.custom_data);
      } catch (e) {
        console.error('Failed to parse custom_data:', e);
      }
    }
    this.AddContactCompanyInfo(this.highlighted_info_contact);
    this.highlightRow(client.guid);
  }

  // Adds to a summary card contact (from the companies already loaded for the list - no extra calls):
  //  - associated_companies: every company they're a contact of, with their role there
  //  - company_groups: groups they're in through those companies. Contact groups and company groups are separate,
  //    so a contact listed under a company group in the address book isn't in that group themselves - these
  //    show alongside their own groups, marked with the company, so the card matches what the list shows.
  private AddContactCompanyInfo(contact: any) {
    if (!contact?.guid) return;
    const own_group_guids = new Set((contact.groups || []).map((g: any) => g.guid));
    const companies: any[] = [];
    const company_groups: any[] = [];
    for (const company of (this.companies || [])) {
      const link = (company.clients || []).find((c: any) => c.guid === contact.guid);
      if (!link) continue;
      companies.push({ guid: company.guid, name: company.name, role_name: link.role_guid ? this.getClientRoleName(link.role_guid) : '' });
      for (const group of (company.groups || [])) {
        if (!group?.guid || own_group_guids.has(group.guid) || company_groups.some(g => g.guid === group.guid)) continue;
        company_groups.push({ ...group, via: company.name });
      }
    }
    contact.associated_companies = companies.sort((a, b) => String(a.name).localeCompare(String(b.name)));
    contact.company_groups = company_groups;
  }

  async highlightRow(guid) {
    this.highlighted_row = guid;
  }

  // The name links in the summary boxes open the details in a modal right here (a new browser tab has to
  // reload the whole app). When it closes, the summary box is reloaded so any edits show straight away.
  async OpenSummaryCompany(company: any) {
    if (!company?.guid) return;
    await this.OpenSummaryDetails(CompaniesDetailsPage, { company: { guid: company.guid } });
  }

  async OpenSummaryContact(contact: any) {
    if (!contact?.guid) return;
    await this.OpenSummaryDetails(ClientDetailsPage, { client: { guid: contact.guid } });
  }

  private async OpenSummaryDetails(component: any, componentProps: any) {
    const modal = await this.modalController.create({
      component,
      cssClass: 'large-modal',
      componentProps,
      backdropDismiss: false
    });
    modal.onDidDismiss().then(async () => {
      window.location.hash = '';
      const row = this.highlighted_row;
      if (!row) return;
      this.highlighted_row = ''; // the highlight functions skip the row that's already highlighted
      if (this.highlighting_company) await this.highlightCompnany({ guid: row });
      else await this.highlightClient({ guid: row }, true);
    });
    return await modal.present();
  }

  async presentFamilyDetails(guid) {
    let client = {
      guid: guid
    }
    this.presentDetailsModal(client);
  }

  async GetClientFamilyMembers(client) {
    let data: any = await this.apiService.get(`clients/family_members/${client.guid}`);
    if (data.success) client.family_members = data.data;
    if (!client.family_members) client.family_members = [];
  }

  //Methods for company stuff
  async presentCompanyDetailsModal(company) {
    console.log("CCM: " + this.current_context_client);
    const modal = await this.modalController.create({
      component: CompaniesDetailsPage,
      cssClass: 'large-modal',
      componentProps: {
        company: company
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {
      window.location.hash = '';
      if (data.data) {
        let client = data.data;
        let index = this.clients.findIndex(item => item.guid === client.guid);
        this.clients[index] = client;

      }
    });
    return await modal.present()
  }


  //Methods for client stuff
  async presentDetailsModal(client) {
    console.log("CCM: " + this.current_context_client);
    const modal = await this.modalController.create({
      component: ClientDetailsPage,
      cssClass: 'large-modal',
      componentProps: {
        client: client
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {
      window.location.hash = '';
      if (data.data) {
        let client = data.data;
        let index = this.clients.findIndex(item => item.guid === client.guid);
        this.clients[index] = client;
        this.CombinedData();
      }
    });
    return await modal.present()
  }

  async DeleteContact(client, company) {
    //Delete the contact if they are not the default contact for a company
    if (company != null) {
      if (company.default_client_guid === client.guid) {
        this.globalService.presentToastMessage('Cannot delete the default contact. Please set a different default contact first.', false);
        return;
      }
    }
    let data: any = await this.apiService.delete(`clients/${client.guid}`, null);
    this.globalService.presentToastMessage(data.message, data.success);


  }

  async setAsDefaultContact(client) {
    if (!this.globalService.validateEmail(client.email)) {
      this.globalService.presentToastMessage('Client must have a valid email address to be set as the default contact.', false);
      return;
    }
    console.log("Client ", client);
    let post_data = {
      default_client_guid: client.guid
    }
    let data: any = await this.apiService.put(`companies/${this.current_context_company.guid}`, post_data);
    if (data.success) this.current_context_company.default_client_guid = client.guid;
  }

  async presentCreateCompanyModal(group) {
    let groups = [];
    if(group != null) groups.push(group);
    if(group == null) this.isClientGroup = true;
    const modal = await this.modalController.create({
      component: CompanyCreatePage,
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        groups: groups,
        is_a_client: this.isClientGroup
      }
    })
    modal.onDidDismiss().then((data: any) => {
      // Local push, no re-fetch - company_groups' .companies arrays are rebuilt purely from
      // this.companies by CombinedData(), so adding the new company there and re-running it is
      // enough (RefreshGroupData's GetData(true) call re-fetches everything for no reason here).
      if (data.data) {
        console.log(data.data);
        if (!this.companies) this.companies = [];
        this.companies.push(data.data);
        this.CombinedData();
        if (group != null) this.ExpandAllParentGroups(group.guid);
      }
    });
    return await modal.present()
  }

  async removeFromCompany(client, company) {
    //Check if they are the current default contact
    if (company.default_client_guid === client.guid) {
      this.globalService.presentToastMessage('Cannot remove the default contact. Please set a different default contact first.', false);
      return;
    }
    console.log("Client ", client);
    let post_data = {
      guid: client.guid
    }
    let data: any = await this.apiService.delete(`companies/clients/${company.guid}`, post_data);
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      //Splice the client from the current company
      this.GetData();
    }
  }

  async ChangeContactClientStatus(client, is_a_client) {
    let data: any = await this.apiService.put(`clients/${client.guid}/toggle_client/${is_a_client}`, null);
    this.globalService.presentToastMessage(data.message, data.success);
    this.RefreshGroupData(this.current_context_group,false);
  }

  // Same activate endpoint the contacts table uses (clients table UpdateActive).
  async TogglePortalAccess(client) {
    const activating = !client.active;
    const alert = await this.alertController.create({
      header: activating ? 'Invite to Portal' : 'Remove Portal Access',
      message: activating
        ? `Are you sure you want to invite <strong>${client.display_name}</strong> to the portal?`
        : `Are you sure you want to remove portal access for <strong>${client.display_name}</strong>?`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Confirm',
          handler: async () => {
            client.active = activating;
            let data: any = await this.apiService.put(`clients/${client.guid}/activate`, client);
            this.globalService.presentToastMessage(data.message, data.success);
            if (!data.success) client.active = !activating; // Revert the change if the update failed
          }
        }
      ]
    });
    await alert.present();
  }



  // Summary card address as mailing label lines - companies keep the street in str_address_1, contacts in str_address
  // (null when there's no address at all, so the Address row hides)
  MailingLabel(entity: any): string[] | null {
    if (!entity) return null;
    const street = entity.str_address_1 !== undefined ? entity.str_address_1 : entity.str_address;
    const lines = MailingLabelLines(street, entity.city, entity.province, entity.postal_code, entity.country);
    return lines.length ? lines : null;
  }

  // Whether a summary card detail has something to show - blank text, and rich text with no actual text in
  // it (e.g. an emptied description editor's "<p><br></p>"), count as nothing.
  HasValue(value: any): boolean {
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value !== 'string') return true;
    return value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() !== '';
  }

  // Summary card custom fields that actually have a value (null when there are none, so the section hides).
  // An unchecked checkbox is still a value (false) - only a field nobody has filled in is left out.
  FilledCustomFields(fields: any): any[] | null {
    if (!Array.isArray(fields)) return null;
    const filled = fields.filter((field: any) => {
      const value = field?.value;
      return value !== null && value !== undefined && !(typeof value === 'string' && value.trim() === '');
    });
    return filled.length ? filled : null;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.globalService.presentToastMessage('Text copied to clipboard', true);
      console.log('Text copied to clipboard');
    }).catch(err => {
      this.globalService.presentToastMessage('Error copying text', false);
      console.error('Error copying text: ', err);
    });
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async Select() {
    let selected_things = [];
    if (this.selectedCompanyGuids.size > 0) {
      for (const guid of this.selectedCompanyGuids) {
        const company = await this.GetCompanyByGUID(guid);
        if (company) {
          company.is_company = true;
          company.role_guid = this.selectedCompanyRoles.get(guid) || '';
          company.role_level = this.getClientRoleLevel(company.role_guid);
          selected_things.push(company);
        } 
      }
    }
    if (this.selectedContactGuids.size > 0) {
      for (const guid of this.selectedContactGuids) {
        const client = this.GetContactByGUID(guid);
        if (client) {
          client.is_contact = true;
          selected_things.push(client);
        } 
      }
    }
    if(this.selectedCompanyGroupGuids.size > 0) {
      for (const guid of this.selectedCompanyGroupGuids) {
        const group = this.company_groups.find(g => g.guid === guid);
        if (group) {
          group.is_company_group = true;
          selected_things.push(group);
        } 
      }
    }
    if(this.selectedContactGroupGuids.size > 0) {
      for (const guid of this.selectedContactGroupGuids) {
        const group = this.client_groups.find(g => g.guid === guid);
        if (group) {
          group.is_contact_group = true;
          selected_things.push(group);
        } 
      }
    }
    if (selected_things.length > 0) this.modalController.dismiss(selected_things);
    else this.modalController.dismiss(null);

  }

  filteredCompanies(query: string): any[] {
    if (!query || !query.trim()) {
      return this.companies;
    }
    const lowerQuery = query.toLowerCase();
    return this.companies.filter(company =>
      (company.name && company.name.toLowerCase().includes(lowerQuery)) ||
      (company.business_number && company.business_number.toLowerCase().includes(lowerQuery)) ||
      (company.custom_id && company.custom_id.toLowerCase().includes(lowerQuery))
    );
  }

  filteredClients(query: string): any[] {
    if (!query || !query.trim()) {
      return this.clients;
    }
    const lowerQuery = query.toLowerCase();
    return this.clients.filter(client =>
      (client.display_name && client.display_name.toLowerCase().includes(lowerQuery)) ||
      (client.email && client.email.toLowerCase().includes(lowerQuery)) ||
      (client.custom_id && client.custom_id.toLowerCase().includes(lowerQuery))
    );
  }

  get isGlobalSearchAllowed(): boolean {
    return this.allow_company_selection || this.allow_contact_selection;
  }

  onGlobalSearchChange(term: string) {
    this.globalSearchTerm = term;
    this.globalFilteredCompanies = this.computeGlobalFilteredCompanies();
    this.globalFilteredContacts = this.computeGlobalFilteredContacts();
  }

  private computeGlobalFilteredCompanies(): any[] {
    if (!this.globalSearchTerm?.trim() || !this.allow_company_selection) return [];
    const q = this.globalSearchTerm.toLowerCase();
    return this.companies.filter(c => {
      const matches = c.name?.toLowerCase().includes(q) ||
        c.business_number?.toLowerCase().includes(q) ||
        c.custom_id?.toLowerCase().includes(q);
      if (!matches) return false;
      if (c.is_a_client && !this.allow_client_selection) return false;
      if (!c.is_a_client && !this.allow_non_client_selection) return false;
      return true;
    });
  }

  private computeGlobalFilteredContacts(): any[] {
    if (!this.globalSearchTerm?.trim() || !this.allow_contact_selection) return [];
    const q = this.globalSearchTerm.toLowerCase();
    return this.clients.filter(c => {
      const matches = c.display_name?.toLowerCase().includes(q) ||
        c.custom_id?.toLowerCase().includes(q);
      if (!matches) return false;
      if (c.is_a_client && !this.allow_client_selection) return false;
      if (!c.is_a_client && !this.allow_non_client_selection) return false;
      return true;
    });
  }

  // Filtered lists for virtual scrolling - clients that are marked as clients
  getFilteredClientCompanies(query: string): any[] {
    return this.filteredCompanies(query).filter(company => company.is_a_client);
  }

  getFilteredClientContacts(query: string): any[] {
    return this.filteredClients(query).filter(client => client.is_a_client);
  }

  // Filtered lists for virtual scrolling - non-clients
  getFilteredNonClientCompanies(query: string): any[] {
    return this.filteredCompanies(query).filter(company => !company.is_a_client);
  }

  getFilteredNonClientContacts(query: string): any[] {
    return this.filteredClients(query).filter(client => !client.is_a_client);
  }

  private sortMixedByName(items: { type: 'company' | 'contact', item: any }[]): { type: 'company' | 'contact', item: any }[] {
    return items.sort((a, b) => {
      const nameA = (a.type === 'company' ? a.item?.name : a.item?.display_name) || '';
      const nameB = (b.type === 'company' ? b.item?.name : b.item?.display_name) || '';
      return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
    });
  }

  trackByMixedEntry(index: number, entry: { type: 'company' | 'contact', item: any }): string {
    return `${entry.type}:${entry.item?.guid || index}`;
  }

  // Companies and contacts mixed together, alphabetically sorted, for the "All Clients" list
  getFilteredClientMixed(query: string): { type: 'company' | 'contact', item: any }[] {
    const showCompanies = (this.allow_company_selection || this.allow_company_group_selection) && this.client_list_filter !== 'contacts';
    const showContacts = (this.allow_contact_selection || this.allow_contact_group_selection) && this.client_list_filter !== 'companies';
    const items: { type: 'company' | 'contact', item: any }[] = [];
    if (showCompanies) this.getFilteredClientCompanies(query).forEach(item => items.push({ type: 'company', item }));
    if (showContacts) this.getFilteredClientContacts(query).forEach(item => items.push({ type: 'contact', item }));
    return this.sortMixedByName(items);
  }

  // Companies and contacts mixed together, alphabetically sorted, for the "All Non Clients" list
  getFilteredNonClientMixed(query: string): { type: 'company' | 'contact', item: any }[] {
    const showCompanies = (this.allow_company_selection || this.allow_company_group_selection) && this.non_client_list_filter !== 'contacts';
    const showContacts = (this.allow_contact_selection || this.allow_contact_group_selection) && this.non_client_list_filter !== 'companies';
    const items: { type: 'company' | 'contact', item: any }[] = [];
    if (showCompanies) this.getFilteredNonClientCompanies(query).forEach(item => items.push({ type: 'company', item }));
    if (showContacts) this.getFilteredNonClientContacts(query).forEach(item => items.push({ type: 'contact', item }));
    return this.sortMixedByName(items);
  }


  //Company Context Menu Options
  async presentCreateClientModal(company, group) {
    let groups = [];
    let company_guid = '';
    let selecting_for_company = false
    if (company != null) {
      selecting_for_company = true;
      company_guid = company.guid;
    } 
    if (group != null) groups.push(group);
    const modal = await this.modalController.create({
      component: ClientCreatePage,
      cssClass: 'tall-modal medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        simple_create: true,
        company_guid: company_guid,
        selecting_for_company: selecting_for_company,
        groups: groups,
        is_a_client: this.isClientGroup
      }
    })
    modal.onDidDismiss().then((data: any) => {
      // Local push, no re-fetch - client_groups' .clients arrays are rebuilt purely from
      // this.clients by CombinedData(). company.clients is the one exception (CombinedData only
      // re-syncs entries already present there, it doesn't add new ones), so push into that too
      // when this contact was created directly under a specific company.
      // The simple create dismisses with the API's result array, the full create with just the row.
      // Pushing the array itself would leave a nested array in this.clients (no display_name, so the
      // search and lists could never match it) - always take the row.
      const created = Array.isArray(data.data) ? data.data[0] : data.data;
      if (created) {
        if (!this.clients) this.clients = [];
        // The API's row is read before the create page assigns groups, so fill them in here
        if (!Array.isArray(created.groups) || created.groups.length === 0) {
          created.groups = groups.map((g: any) => ({ guid: g.guid, title: g.title, colour: g.colour, description: g.description }));
        }
        this.clients.push(created);
        this.clients.sort((a: any, b: any) => (a?.display_name || '').toLowerCase().localeCompare((b?.display_name || '').toLowerCase()));
        if (created.groups.length === 0) {
          if (created.is_a_client) this.non_grouped_contacts_clients++;
          else this.non_grouped_contacts_not_clients++;
        }
        if (company != null) {
          if (!company.clients) company.clients = [];
          company.clients.push(created);
        }
        this.CombinedData();
        // Recompute the search results in case a search is already open
        this.onGlobalSearchChange(this.globalSearchTerm);
      }
    });
    return await modal.present()
  }

  async presentManageCompaniesGroups(company) {
    let _url = 'companies';
    let groups = [];
    if (company.groups) groups = JSON.parse(JSON.stringify(company.groups));
    //Loop through the current companies/clients in the group and move them to another group
    const modal = await this.modalController.create({
      component: GroupSelectComponent,
      cssClass: 'large-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        url: _url,
        selected_groups: groups
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        let copy_groups = [];
        if (company.groups) copy_groups = JSON.parse(JSON.stringify(company.groups));

        await this.CheckCompanyGroups(copy_groups, data.data, company);
        //Refresh the data on the page
        await this.RefreshGroupData(null,false);
        await this.globalService.dismissLoading();
      }
    });
    return await modal.present();
  }

  //See if we have to remove or add groups
  async CheckCompanyGroups(old_groups, new_groups, company) {
    console.log("OLD GROUPS: ", old_groups);
    console.log("NEW GROUPS: ", new_groups);
    await this.globalService.presentLoading("Updating Groups", 999999);
    //Check to see if all the old groups still exist, if not we will run a delete statement to the api
    for (let i = 0; i < old_groups.length; i++) {
      const group = old_groups[i];
      const index = new_groups.findIndex(e => group.guid === e.guid);
      if (index === -1) {
        console.log("REMOVE GROUP: ");
        await this.RemoveCompanyFromGroup(company, group);
      }
    }
    //If the old group does not exist in the new groups, run api statement to add it
    for (let i = 0; i < new_groups.length; i++) {
      const newGroup = new_groups[i];
      const index = old_groups.findIndex(e => newGroup.guid === e.guid);
      if (index == -1) {
        console.log("ADD GROUP");
        await this.AddCompanyToGroup(company, newGroup);
      }
    }
    this.globalService.dismissLoading();
  }



  //Logic for groups
  async DeleteGroup(group) {
    if (!group) return;
    if (this.isCompanyGroup && group.companies && group.companies.length > 0) {
      this.globalService.presentToastMessage('Cannot delete a group that has companies assigned to it. Please move the companies to a different group first.', false);
      return;
    }
    if (!this.isCompanyGroup && group.clients && group.clients.length > 0) {
      this.globalService.presentToastMessage('Cannot delete a group that has contacts assigned to it. Please move the contacts to a different group first.', false);
      return;
    }
    if (this.isCompanyGroup) {
      let data: any = await this.apiService.delete(`groups/companies/${group.guid}/false`, null);
      if (data.success) {
        let companyGroupIndex = this.company_groups.findIndex(item => item.guid === group.guid);
        if (companyGroupIndex > -1) this.company_groups.splice(companyGroupIndex, 1);
      }
      this.globalService.presentToastMessage(data.message, data.success);

    }
    else {
      let data: any = await this.apiService.delete(`groups/clients/${group.guid}/false`, null);
      if (data.success) {
        // Remove the group from the local list
        let clientGroupIndex = this.client_groups.findIndex(item => item.guid === group.guid);
        if (clientGroupIndex > -1) this.client_groups.splice(clientGroupIndex, 1);
      }
      this.globalService.presentToastMessage(data.message, data.success);
    }
  }

  async AddNewGroup(parent_group, isCompanyGroup) {
    console.log("Incoming parent group: ", parent_group);
    let _url = 'companies';
    if (!isCompanyGroup) _url = 'clients';
    const modal = await this.modalController.create({
      component: GroupCreateComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        url: _url,
        parent_group: parent_group,
        edit_mode: false
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        // Refresh company groups and recombine data after a new subgroup is created
        await this.GetCompanyGroups();
        this.CombinedData();
        this.ExpandAllParentGroups(parent_group.guid);
      }
    });

    return await modal.present();
  }

  async UpdateGroup(current_group) {
    let _url = 'companies';
    if (!this.isCompanyGroup) _url = 'clients';
    let parent_group = {
      guid: current_group.parent_guid,
    }
    const modal = await this.modalController.create({
      component: GroupCreateComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        add_group: JSON.parse(JSON.stringify(current_group)),
        url: _url,
        edit_mode: true,
        parent_group: parent_group
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        // Refresh company groups and recombine data after a new subgroup is created
        await this.GetCompanyGroups();
        this.CombinedData();
        this.ExpandAllParentGroups(parent_group.guid);
      }
    });

    return await modal.present();
  }

  async MoveToAnotherGroup(group, delete_from_current) {
    if (!group) return;
    if (this.isCompanyGroup && group.companies.length == 0) {
      this.globalService.presentToastMessage('This group must have companies in it before moving these companies to another group.', false);
      return;
    }
    if (!this.isCompanyGroup && group.clients.length == 0) {
      this.globalService.presentToastMessage('This group must have contacts in it before moving these contacts to another group.', false);
      return;
    }
    let _url = 'companies';
    if (!this.isCompanyGroup) _url = 'clients';
    //Loop through the current companies/clients in the group and move them to another group
    const modal = await this.modalController.create({
      component: GroupSelectComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        url: _url,
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        let new_groups = data.data;
        await this.globalService.presentLoading("Updating Groups", 999999);
        // // Refresh company groups and recombine data after a new subgroup is created
        // await this.GetCompanyGroups();
        // this.CombinedData();
        // this.ExpandAllParentGroups(group.guid);
        if (delete_from_current) {
          this.RemoveFromGroup(group, false);
        }
        //Loop through the selected groups and add the companies/clients to the new group
        for (let i = 0; i < new_groups.length; i++) {
          const new_group = new_groups[i];

          if (this.isCompanyGroup) {

            for (let j = 0; j < group.companies.length; j++) {
              let company = group.companies[j];
              await this.globalService.presentLoading(`Adding ${company.name} to ${new_group.title}`, 999999);
              console.log("Adding Company to Group: ", company, new_group);
              await this.AddCompanyToGroup(company, new_group);
            }
          } else {
            for (let j = 0; j < group.clients.length; j++) {
              let client = group.clients[j];
              await this.globalService.presentLoading(`Adding ${client.display_name} to ${new_group.title}`, 999999);
              await this.AddClientToGroup(client, new_group);
            }
          }
        }
        //Refresh the data on the page
        await this.RefreshGroupData(group,false);
        await this.globalService.dismissLoading();
      }
    });
    return await modal.present();
  }

  async RemoveFromGroup(group, confirm) {
    if (!group) return;
    if (this.isCompanyGroup && group.companies.length == 0) {
      this.globalService.presentToastMessage('This group must have companies in it before moving these companies to another group.', false);
      return;
    }
    if (!this.isCompanyGroup && group.clients.length == 0) {
      this.globalService.presentToastMessage('This group must have contacts in it before moving these contacts to another group.', false);
      return;
    }
    if (confirm) {
      const entity = this.isCompanyGroup ? 'companies' : 'contacts';
      const groupName = group && group.name ? ` "${group.name}"` : '';
      const confirmation = window.prompt(`Are you sure you want to remove all ${entity} from the group ${groupName}? This action cannot be undone. Please type "Remove" to confirm:`);
      if (confirmation !== 'Remove') {
        this.globalService.presentToastMessage('Operation cancelled', false);
        return;
      }
    }
    if (confirm) await this.globalService.presentLoading("Removing from Group", 999999);
    if (this.isCompanyGroup) {
      //Loop through the groups clients / companies and remove them from the current group with an api call
      for (let i = 0; i < group.companies.length; i++) {
        let company = group.companies[i];
        await this.RemoveCompanyFromGroup(company, group);
      }
    }
    else {
      for (let i = 0; i < group.clients.length; i++) {
        let client = group.clients[i];
        await this.RemoveClientFromGroup(client, group);
      }
    }
    await this.RefreshGroupData(group,false);
    if (confirm) await this.globalService.dismissLoading();
    return true;
  }

  async RefreshGroupData(group, force) {
    // Always forced - every caller here is refreshing after some data-changing action (create,
    // group membership change, etc.), so a non-forced GetData() risks serving the stale cached
    // list back unchanged if the backend's updates delta check doesn't catch the change yet.
    this.GetData(true);

    // //Refresh the data on the page
    // if (this.isCompanyGroup || force) {
    //   await this.GetCompanies();
    //   await this.GetCompanyGroups();
    // }
    // if(!this.isCompanyGroup || force) {
    //   await this.GetClients();
    //   await this.GetClientGroups();
    // }
    // this.CombinedData();
    // if (group != null) this.ExpandAllParentGroups(group.guid);

  }

  async RemoveCompanyFromGroup(company, group) {
    let data: any = await this.apiService.delete(`groups/companies/${company.guid}`, group);
    return data;
  }

  async AddCompanyToGroup(company, group) {
    let data: any = await this.apiService.post(`groups/companies/${company.guid}`, group);
    return data;
  }

  async RemoveClientFromGroup(client, group) {
    let data: any = await this.apiService.delete(`groups/clients/${client.guid}`, group);
    return data;
  }

  async AddClientToGroup(client, group) {
    let data: any = await this.apiService.post(`groups/clients/${client.guid}`, group);
    return data;
  }

  ExpandAllParentGroups(parent_guid) {
    //Loop through and expand all parent groups
    if (!parent_guid) return;
    const groupsArray = this.isCompanyGroup ? this.company_groups : this.client_groups;
    // Flat architecture: groupsArray is a flat list and parent-child relation is via parent_guid on each group
    const findGroupByGuid = (groups: any[], guid: string): any => {
      return groups.find(g => g.guid === guid) || null;
    };

    const group = findGroupByGuid(groupsArray, parent_guid);
    if (group) {
      group.expanded = true;
      if (group.parent_guid) {
        this.ExpandAllParentGroups(group.parent_guid);
      }
    }
  }



  //Buttons at the top row
  async DisableMultiSelection() {
    this.selectedContactGuids.clear();
    this.selectedClientGuids.clear();
    this.selectedCompanyGuids.clear();
    this.selectedContactGroupGuids.clear();
    this.selectedCompanyGroupGuids.clear();
    this.selectedCompanyRoles.clear();
    this.selection_mode = false;
  }

  async ChangeSelectedCompaniesClientStatus(make_a_client) {
    await this.globalService.presentLoading("Updating Companies", 999999);
    for (const guid of this.selectedCompanyGuids) {
      let data: any = await this.apiService.put(`companies/${guid}/toggle_client/${make_a_client}`, null);
      this.globalService.presentToastMessage(data.message, data.success);
    }
    await this.RefreshDataTopRow();
    await this.globalService.dismissLoading();
  }

  async ChangeSelectedContactsClientStatus(make_a_client) {
    await this.globalService.presentLoading("Updating Contacts", 999999);
    for (const guid of this.selectedContactGuids) {
      let data: any = await this.apiService.put(`clients/${guid}/toggle_client/${make_a_client}`, null);
      this.globalService.presentToastMessage(data.message, data.success);
    }
    await this.RefreshDataTopRow();
    await this.globalService.dismissLoading();
  }

  async RemoveFromAllGroups() {
    const confirmation = window.prompt('Please type "Remove" to confirm removing selected items from all groups they are in. This cannot be undone.:');
    if (confirmation !== 'Remove') {
      this.globalService.presentToastMessage('Operation cancelled', false);
      return;
    }
    await this.globalService.presentLoading("Removing from all groups", 999999);
    for (const guid of this.selectedContactGuids) {
      //Find the matching contact and loop through all their groups to remove them
      const client = this.clients.find(c => c.guid === guid);
      if (client && client.groups) {
        for (const group of client.groups) {
          await this.RemoveClientFromGroup(client, group);
        }
      }
    }
    for (const guid of this.selectedCompanyGuids) {
      // Find the matching company and loop through all their groups to remove them
      const company = this.companies.find(c => c.guid === guid);
      if (company && company.groups) {
        for (const group of company.groups) {
          await this.RemoveCompanyFromGroup(company, group);
        }
      }
    }
    await this.RefreshDataTopRow();
    await this.globalService.dismissLoading();

  }

  async AddToGroup() {
    let _url = 'companies';
    if (this.selectedCompanyGuids.size == 0) _url = 'clients';
    //Loop through the current companies/clients in the group and move them to another group
    const modal = await this.modalController.create({
      component: GroupSelectComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        url: _url,
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        let new_groups = data.data;
        await this.globalService.presentLoading("Updating Groups", 999999);

        //Loop through the selected groups and add the companies/clients to the new group
        for (let i = 0; i < new_groups.length; i++) {
          const new_group = new_groups[i];

          for (const guid of this.selectedContactGuids) {
            //Find the matching contact and loop through all their groups to remove them
            const client = this.clients.find(c => c.guid === guid);
            await this.AddClientToGroup(client, new_group);
          }
          for (const guid of this.selectedCompanyGuids) {
            // Find the matching company and loop through all their groups to remove them
            const company = this.companies.find(c => c.guid === guid);
            await this.AddCompanyToGroup(company, new_group);
          }

        }
        await this.RefreshDataTopRow();
        await this.globalService.dismissLoading();

      }
    });
    return await modal.present();
  }


  async AddToCompany() {
    //Loop through the current companies/clients in the group and move them to another group
    const modal = await this.modalController.create({
      component: AddressBookComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        external_selection_mode: true,
        allow_contact_selection: false,
        allow_company_group_selection: false,
        allow_contact_group_selection: false
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        let selected_companies = data.data;
        let contacts = [];
        for (const guid of this.selectedContactGuids) {
          const contact = this.clients.find(c => c.guid === guid);
          if (contact) contacts.push(contact);
        }
        console.log("Contacts to add: ", contacts);
        await this.presentSelectCompanyRolesModal(contacts, selected_companies);
        // ;
        // console.log("Selected Companies: ", selected_companies);
        // let roles_data: any = await this.apiService.get('firms/clients/roles');
        // let roles = [];
        // if (roles_data.success) roles = roles_data.data;
        // console.log("Roles: ", roles);



        
        // await this.globalService.presentLoading("Adding to Companies", 999999);
        // for (let i = 0; i < this.selectedContactGuids.size; i++) {
        //   const guid = Array.from(this.selectedContactGuids)[i];
        //   const client = this.clients.find(c => c.guid === guid);

        // }
        // for (let i = 0; i < selected_companies.length; i++) {
        //   const company = selected_companies[i];
        //   console.log("Selected Company: ", company);
        // }
        // await this.RefreshDataTopRow();
        // await this.globalService.dismissLoading();

      }
    });
    return await modal.present();
  }

  async presentSelectCompanyRolesModal(contacts, companies) {
    //Loop through the current companies/clients in the group and move them to another group
    const modal = await this.modalController.create({
      component: SelectCompanyRoleComponent,
      cssClass: 'medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        contacts: contacts,
        companies: companies
      }
    });

    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data) {
        let returned_data = data.data;
        await this.globalService.presentLoading("Adding to Companies", 999999);
        for (let i = 0; i < returned_data.length; i++) {
          const item = returned_data[i];
          const client_guid = item.client_guid;
          const company = this.companies.find(c => c.guid === item.company_guid);
          const clientObj = this.clients.find(c => c.guid === client_guid);
          await this.globalService.presentLoading(`Assigning ${clientObj.display_name} to ${company.name}`, 999999);
          const company_guid = item.company_guid;
          const role_guid = item.role_guid;
          let post_data = {
            guid: client_guid,
            role_guid: role_guid
          }
          let data: any = await this.apiService.post(`companies/clients/${company_guid}`, post_data);
          this.globalService.presentToastMessage(data.message, data.success);
        }
        this.RefreshGroupData(null,true);
        await this.globalService.dismissLoading();

      }
    });
    return await modal.present();
  }

  async RefreshDataTopRow() {
    this.GetData();

    // if (this.selectedContactGuids.size > 0) {
    //   await this.GetClients();
    //   await this.GetClientGroups();
    // }
    // else if (this.selectedCompanyGuids.size > 0) {
    //   await this.GetCompanies();
    //   await this.GetCompanyGroups();
    // }
    // this.selectedContactGuids.clear();
    // this.selectedClientGuids.clear();
    // this.selectedCompanyGuids.clear();
    // this.selectedCompanyGroupGuids.clear();
    // this.selectedContactGroupGuids.clear();
    // this.CombinedData();
  }




  //tooltip generation
  GenerateClientTooltip(client) {
    let message = '';
    if (client.display_name) message += `<b>Name:</b> ${client.display_name}<br/>`;
    if (client.username) message += `<b>Username:</b> ${client.username}<br/>`;
    if (client.email) message += `<b>Email:</b> ${client.email}<br/>`;
    if (client.phone) message += `<b>Phone:</b> ${client.phone}<br/>`;
    // Portal access (check common property names) and client status
    message += `<b>Portal Access:</b> ${client.active ? 'Yes' : 'No'}<br/>`;
    message += `<b>Is Client:</b> ${client.is_a_client ? 'Yes' : 'No'}<br/>`;
    return message;
  }

  GenerateCompanyTooltip(company) {
    let message = '';
    if (company.name) message += `<b>Company Name:</b> ${company.name}<br/>`;
        if (company.year_end_date) { 
      let yed = company.year_end_date;
      const date = new Date(yed);
      yed = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      message += `<b>Year End Date:</b> ${yed}<br/>`;

  }
    // Show default contact info (a horizontal line, then client tooltip)
    if (company.default_client_guid) {
      message += `<hr/>`;
      message += `<b>Default Contact Information</b><br/>`;
      let defaultClient = null;
      if (company.clients && Array.isArray(company.clients)) {
        defaultClient = company.clients.find((c: any) => c.guid === company.default_client_guid);
      }
      if (!defaultClient && this.clients && Array.isArray(this.clients)) {
        defaultClient = this.clients.find((c: any) => c.guid === company.default_client_guid);
      }
      if (defaultClient) {
        message += this.GenerateClientTooltip(defaultClient);
      }
    }
    return message;
  }


}
